/**
 * Black-Scholes option pricing implementation
 */

import {
  calculateD1,
  calculateD2,
  cumulativeNormalDistribution,
} from './math-utils';
import { OptionParameters } from './types';

/**
 * Calculates Black-Scholes option price
 */
export function blackScholesPrice(params: OptionParameters): number {
  const {
    underlyingPrice: S,
    strikePrice: K,
    timeToExpiry: T,
    riskFreeRate: r,
    volatility: sigma,
    optionType,
  } = params;

  if (T <= 0) {
    return Math.max(optionType === 'call' ? S - K : K - S, 0);
  }
  if (sigma <= 0) {
    return Math.max(optionType === 'call' ? S - K : K - S, 0);
  }

  const d1 = calculateD1(S, K, T, r, sigma);
  const d2 = calculateD2(d1, sigma, T);

  const Nd1 = cumulativeNormalDistribution(d1);
  const Nd2 = cumulativeNormalDistribution(d2);
  const NegD1 = cumulativeNormalDistribution(-d1);
  const NegD2 = cumulativeNormalDistribution(-d2);

  return optionType === 'call'
    ? S * Nd1 - K * Math.exp(-r * T) * Nd2
    : K * Math.exp(-r * T) * NegD2 - S * NegD1;
}
